/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const orphanedInstanceTalliesSchema = z.object({
  holidaySchemes: z.int(),
  resourceIdentities: z.int(),
  skills: z.int(),
  teamRoles: z.int(),
  teams: z.int(),
  workloadSchemes: z.int(),
});
